import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import strings from 'utils/strings'

import { selectPtoVehicleFragments } from 'selectors/powerTakeOff'

import RoundedTagIcon from 'img/rounded-tag.svg'
import {
  NotesTitle,
  TemplateName,
  StyledFragmentList,
  StyledTextArea,
  RoudedTagItem,
  FragmentValueFlexWrapper,
} from './PtoTemplateNotes.style'
import { StyledTable } from '../PtoTemplateDiffTable/PtoTemplateDiffTable.style'

const PtoTemplateNotes = ({
  handleNotesChange,
  selectedDomains,
  useRoundOffSettings,
  deleteInvalidSettings,
}) => {
  const [notesVal, setNotesVal] = useState('')

  const ptoVehicleFragmentsList = useSelector(selectPtoVehicleFragments)

  const onNotesChange = (e) => {
    setNotesVal(e.target.value)
    handleNotesChange(e.target.value)
  }

  const columns = useMemo(
    () => [
      {
        title: strings.domain,
        dataIndex: 'domainId',
        key: 'domainId',
        width: '42.39%',
      },
      {
        title: strings.name_title,
        dataIndex: 'name',
        key: 'name',
        width: '42.39%',
      },
      {
        title: strings.value,
        dataIndex: 'templateValue',
        key: 'templateValue',
        width: '15.20%',
        render: (value, { isFragmentOutOfRange }) => {
          return (
            <FragmentValueFlexWrapper>
              <span>{value}</span>
              {isFragmentOutOfRange && useRoundOffSettings && (
                <RoudedTagItem src={RoundedTagIcon} />
              )}
            </FragmentValueFlexWrapper>
          )
        },
      },
    ],
    [useRoundOffSettings]
  )

  const renderFragmentListForSave = useMemo(() => {
    const data = ptoVehicleFragmentsList.filter((item) => {
      if (selectedDomains[item.fragmentDomainId]) {
        if (deleteInvalidSettings) {
          return !item.isFragmentOutOfRange
        }
        return true
      }
      return false
    })

    return (
      <StyledTable
        columns={columns}
        dataSource={data}
        pagination={false}
        yScroll={350}
        rowKey={(record) => record.refNo}
      />
    )
  }, [selectedDomains, columns, deleteInvalidSettings, ptoVehicleFragmentsList])

  return (
    <>
      <NotesTitle>
        <TemplateName size="large" weight="bold">
          {strings.create_template}
        </TemplateName>
      </NotesTitle>
      <StyledFragmentList>{renderFragmentListForSave}</StyledFragmentList>
      <StyledTextArea
        size="large"
        onChange={onNotesChange}
        value={notesVal}
        placeholder={strings.notes_required}
        autosize={{ minRows: 8, maxRows: 15 }}
        maxLength={1000}
        data-testid="pto-template-notes-textarea"
      />
    </>
  )
}

PtoTemplateNotes.propTypes = {
  handleNotesChange: PropTypes.func,
  selectedDomains: PropTypes.object,
  useRoundOffSettings: PropTypes.bool,
  deleteInvalidSettings: PropTypes.bool,
}

export default PtoTemplateNotes
